/**
 * RouteAccessBoundary — enforces backend route decisions.
 *
 * Concealed routes render as not-found, authorization restrictions render as
 * forbidden, and implementation/operational states use distinct content.
 */
import type { ReactNode } from 'react';
import { useRouteAccess } from './use-route-access';
import { RouteAccessStateView } from './RouteAccessStateView';

export interface RouteAccessBoundaryProps {
  routeId: string;
  children: ReactNode;
}

export function RouteAccessBoundary({ routeId, children }: RouteAccessBoundaryProps) {
  const access = useRouteAccess(routeId);
  const state = <RouteAccessStateView routeId={routeId} access={access} />;

  if (access.status !== 'AVAILABLE' && access.status !== 'READ_ONLY') {
    return state;
  }

  return <>{children}</>;
}
